var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section is-medium logos"},[_c('div',{staticClass:"container"},[_c('logos-for-clause',{attrs:{"logos":_vm.section.logos_line1}}),_c('logos-for-clause',{staticClass:"margin-bottom-medium-negate",attrs:{"logos":_vm.section.logos_line2}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }